import { render, staticRenderFns } from "./SuccessDeal.vue?vue&type=template&id=c2f6beaa&"
import script from "./SuccessDeal.vue?vue&type=script&lang=js&"
export * from "./SuccessDeal.vue?vue&type=script&lang=js&"
import style0 from "./SuccessDeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports